import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ACCESS_TOKEN, ROL_USER, USER_ID, USER_NAME } from "../../app/api-client/constants";
import { request } from "../../app/api-client/ApiClient";

// const request = (options, state) => {
//     const headers = new Headers({
//         "Content-Type": "application/json",
//     });

//     const defaults = { headers: headers };
//     options = Object.assign({}, defaults, options);

//     return fetch(options.url, options)
//         .then((response) => response.json())
//         .then((json) => {
//             if (json.status === 401) {
//                 return {
//                     ...json,
//                     error: true,
//                     process: 'failed',
//                 };
//             }

//             return { error: false, ...json };
//         });
// };

export const postLogin = createAsyncThunk(
    'user/login',
    async (login) => {
    
        return await request({
            url: `${process.env.REACT_APP_API_URL}/api/auth/signin`,
            method: "POST",
            body: JSON.stringify(login),
        });


    }
)

const userSlice = createSlice({
    name: "user",
    initialState: {
        user: null,
        loginToken: {},
        process: null,
        isLoading: false,
        payload: { error: false }
    },
    reducers: {
        loginBytoken: (state) => {
            let token =localStorage.getItem(ACCESS_TOKEN)
            state.user = {accessToken:token}
        },
        logout: (state) => {
            state.user = null;
            localStorage.removeItem(ACCESS_TOKEN);
            localStorage.removeItem(USER_ID);
            localStorage.removeItem(ROL_USER);
            localStorage.clear();

        },
    },
    extraReducers: {
        [postLogin.pending]: (state, action) => {
            state.process = 'loading'
            state.isLoading = true
            state.payload = { error: false }
        },
        [postLogin.fulfilled]: (state, { payload }) => {

            try{
               
                state.payload = payload
                state.loginToken = !payload.error ? payload : {}
                state.process = 'success'
                state.isLoading = false
    
                state.loginToken.accessToken && localStorage.setItem(ACCESS_TOKEN, payload.accessToken);
                payload.userPrincipal && localStorage.setItem(ROL_USER, payload.userPrincipal.authorities[0].authority)
                payload.userPrincipal && localStorage.setItem(USER_ID, payload.userPrincipal.id)
                payload.userPrincipal && localStorage.setItem(USER_NAME, payload.userPrincipal.name)
                state.user = state.loginToken.userPrincipal &&  state.loginToken.userPrincipal
                
            }catch(error){
                console.error(error)
                state.isLoading = false
                state.payload = { error: true }
            }

        },
        [postLogin.rejected]: (state, action) => {
            state.process = 'failed'
            state.isLoading = false
            state.payload = { error: true }

        },
    },

});

export const {  logout, loginBytoken  } = userSlice.actions;

export const selectUser = (state) => state.user.user;

export const selectLoginApiStatus = (state) => state.user.process

export const selectPayload = (state) => state.user.payload

export const selectLoading = (state) => state.user.isLoading

export default userSlice.reducer;